export const TOGGLE_ASSET_CATEGORY_SELECTION = "TOGGLE_ASSET_CATEGORY_SELECTION";
export const TOGGLE_ASSET_CATEGORY_EXPANDED_SELECTION = "TOGGLE_ASSET_CATEGORY_EXPANDED_SELECTION";
export const TOGGLE_ASSET_ITEM_SELECTION = "TOGGLE_ASSET_ITEM_SELECTION";
export const RESET_ASSET_SELECTION = "RESET_ASSET_SELECTION";
export const SET_ASSET_SELECTION = "SET_ASSET_SELECTION";
export const SELECT_MULTIPLE_ASSET_ITEMS = "SELECT_MULTIPLE_ASSET_ITEMS";
export const SELECT_MULTIPLE_ASSET_CATEGORY_ITEMS = "SELECT_MULTIPLE_ASSET_CATEGORY_ITEMS";
export const TOGGLE_ORGANIZATION_PROPERTY_EXPANDED_SELECTION = "TOGGLE_ORGANIZATION_PROPERTY_EXPANDED_SELECTION";
export const TOGGLE_OTHER_ASSET_CATEGORY_EXPANDED_SELECTION = "TOGGLE_OTHER_ASSET_CATEGORY_EXPANDED_SELECTION";
